module.exports = __webpack_public_path__ + "assets/img/3_1823_big.1ffedd0c.jpg";